/* eslint-disable no-unused-expressions */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable radix */
/* eslint-disable prefer-template */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable semi */
/* eslint-disable arrow-parens */
const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const blockIconURI = require('./cusoft-logo.svg');
const menuIconURI = blockIconURI;

class Cusoft {
    constructor(runtime) {
        /**
         * The runtime instantiating this block package.
         * @type {Runtime}
         */
        this.runtime = runtime; //vm运行环境
        this.brainData = {};//脑电检测数据
        this.brainScienceData = []; //脑电检测图表数据
        this.socket = ''; //socket请求
        this.maxRecord = 15; //数据最大存储记录数
    }

    //获取token
    getAccessToken() {
        let _search = location.search;
        location._query = {};
        location._query['lang'] = 'en';
        let queryArray = [];
        if (_search) {
            _search = _search.replace('?', '');
            queryArray = _search.split('&');
            for (var i = 0; i < queryArray.length; i++) {
                location._query[queryArray[i].split('=')[0]] = queryArray[i].split('=')[1];
            }
        }
        let accessToken = location._query['accessToken'];
        let domain = location._query['domain'] || 'https://coursedev.e-ai-edu.com';
        return {
            accessToken,
            domain
        }
    }

    //socket 连接
    connectSocket(url) {
        const _this = this;

        return new Promise(function (resolve, reject) {
            _this.socket = new WebSocket(url);
            _this.socket.onopen = (event) => {
                // _this.socket.send(JSON.stringify({
                //     "cmd": 37,
                //     "token":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2d1aWQiOiJ7MThBRTBEQ"
                //    }));
                _this.socket.send(JSON.stringify({ cmd: 10 }));
                resolve(JSON.stringify(event));
            };
            _this.socket.onmessage = (event) => {
                const datas = JSON.parse(event.data || {});
                // console.log("datas", datas);
                //设备连接状态
                if (datas && datas.cmd == 11) {
                    //设备id
                    const connid = datas.connid || '';
                    connid && _this.getCuLinkToken(connid);
                    //设备未连接
                    if (datas.connect == -1) {
                        //设备搜索并建立连接
                        _this.socket.send(JSON.stringify({ cmd: 17, did: '' }));
                    }
                }
                //正常 数据接收
                else if (datas && datas.cmd == 256) {
                    if (_this.brainScienceData.length >= _this.maxRecord) {
                        _this.brainScienceData.shift();
                    }
                    _this.handleData(datas, ...Object.keys(datas))
                }
            };
            _this.socket.onclose = (event) => {
                reject('socket.onclose: ' + JSON.stringify(event));
            };
            _this.socket.onerror = (event) => {
                reject('socket.onerror: ' + JSON.stringify(event));
            };
        });
    }

    //数据处理 
    handleData(datas, ...args) {
        const obj = {};
        const keysArray = ['delta', 'theta', 'alpha1', 'alpha2', 'beta1', 'beta2', 'gamma1', 'gamma2']
        args.forEach(item => {
            const _data = keysArray.indexOf(item) > -1 ? this.LOG2E(datas[item]) : datas[item];
            this.brainData[item] = _data;
            obj[item] = _data;
        })
        this.brainScienceData.push(obj);
    }

    //值取对数
    LOG2E(param) {
        return Math.round(Math.LOG2E * Math.log(param))
    }

    /**
     * @returns {object} metadata for this extension and its blocks.
     */
    getInfo() {
        return {
            // 详细介绍：https://github.com/LLK/scratch-vm/blob/develop/docs/extensions.md
            id: 'cusoft',
            name: '脑科学',
            // Optional: URI for an icon to be displayed in the blocks category menu.
            menuIconURI: menuIconURI,
            // Optional: URI for a block icon, to display at the edge of each block for this
            blockIconURI: blockIconURI,
            color1: '#3076D6',
            // color2: '#25ab9e',
            // color3: '#21988c',
            // Optional: Link to documentation content for this extension.
            // If not present, offer no link.
            // docsURI: 'https://....',
            // 插件右上角的硬件连接状态显示按钮
            showStatusButton: false,
            blocks: [
                {
                    opcode: 'changeBrainwaveConnection',
                    blockType: BlockType.COMMAND,
                    text: '脑波 [connectionStatus]',
                    arguments: {
                        connectionStatus: {
                            type: ArgumentType.STRING,
                            menu: 'connectionStatus',
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'showBrainwaveDelta',
                    blockType: BlockType.REPORTER,
                    text: 'delta(δ)'
                },
                {
                    opcode: 'showBrainwaveTheta',
                    blockType: BlockType.REPORTER,
                    text: 'theta(θ)'
                },
                {
                    opcode: 'showBrainwaveLowAlpha',
                    blockType: BlockType.REPORTER,
                    text: 'lowAlpha(α1)'
                },
                {
                    opcode: 'showBrainwaveHighAlpha',
                    blockType: BlockType.REPORTER,
                    text: 'highAlpha(α2)'
                },
                {
                    opcode: 'showBrainwaveLowBeta',
                    blockType: BlockType.REPORTER,
                    text: 'lowBeta(β1)'
                },
                {
                    opcode: 'showBrainwaveHighBeta',
                    blockType: BlockType.REPORTER,
                    text: 'highBeta(β2)'
                },
                {
                    opcode: 'showBrainwaveLowGamma',
                    blockType: BlockType.REPORTER,
                    text: 'lowGamma(γ1)'
                },
                {
                    opcode: 'showBrainwaveHighGamma',
                    blockType: BlockType.REPORTER,
                    text: 'highGamma(γ2)'
                },
                {
                    opcode: 'showBrainwaveAtt',
                    blockType: BlockType.REPORTER,
                    text: '专注度',
                    // text: formatMessage({
                    //     id: 'cusoft.concentration',
                    //     default: 'Concentration',
                    //     description: "User's current concentration"
                    // })
                },
                {
                    opcode: 'showBrainwaveMed',
                    blockType: BlockType.REPORTER,
                    text: '放松度',
                    // text: formatMessage({
                    //     id: 'cusoft.relaxation',
                    //     default: 'Relaxation',
                    //     description: 'The user’s current mental calmness and relaxation'
                    // })
                },
                {
                    opcode: 'showBrainCharts',
                    blockType: BlockType.COMMAND,
                    text: '脑电参数检测'
                }
            ],
            menus: {
                connectionStatus: [
                    { text: '连接', value: '1' },
                    { text: '断开连接', value: '2' }
                ],
            }
        };
    }

    //鉴权
    getCuLinkToken(device_id) {
        const { accessToken, domain } = this.getAccessToken();
        fetch(`${domain}/api/cusofts/cuLinkToken?access_token=${accessToken}&device_id=${device_id}`, {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((responseJsonData) => {
                if (responseJsonData.error) {
                    throw responseJsonData;
                }
                const token = responseJsonData.token || '';
                this.socket.send(JSON.stringify({
                    "cmd": 37,
                    "token": token
                }))
            })
            .catch((error) => {
                if (error.error) {
                    console.log(error.error.message);
                } else {
                    console.log(error);
                }
            });
    }

    showBrainwaveDelta() {
        return this.brainData.delta || 0;
    }

    showBrainwaveTheta() {
        return this.brainData.theta || 0;
    }

    showBrainwaveLowAlpha() {
        return this.brainData.alpha1 || 0;
    }

    showBrainwaveHighAlpha() {
        return this.brainData.alpha2 || 0;
    }

    showBrainwaveLowBeta() {
        return this.brainData.beta1 || 0;
    }

    showBrainwaveHighBeta() {
        return this.brainData.beta2 || 0;
    }

    showBrainwaveLowGamma() {
        return this.brainData.gamma1 || 0;
    }

    showBrainwaveHighGamma() {
        return this.brainData.gamma2 || 0;
    }

    showBrainwaveAtt() {
        return this.brainData.att || 0;
    }

    showBrainwaveMed() {
        return this.brainData.med || 0;
    }

    changeBrainwaveConnection(args) {
        const { connectionStatus } = args;
        if (this.getRunMode() != 1) {
            alert('烧录模式无法执行交互')
            return
        }
        if (!this.socket && connectionStatus == 1) {
            console.log("开始连接");
            const url = 'ws://localhost:16702/'
            this.connectSocket(url);
        } else if (this.socket && connectionStatus == 2) {
            console.log("断开连接");
            this.socket.close();
            this.socket = '';
            this.clearChartsData();
        }
    }

    //初始化默认数据或测试数据
    initTestData(isReset) {
        const keysArray = ['delta', 'theta', 'alpha1', 'alpha2', 'beta1', 'beta2', 'gamma1', 'gamma2', 'att', 'med']
        const obj = {};
        keysArray.forEach(item => {
            if (item == 'att' || item == 'med') {
                isReset ? obj[item] = 0 : obj[item] = Math.round(Math.random() * 100)
            } else {
                isReset ? obj[item] = 0 : obj[item] = Math.round(Math.random() * 24)
            }
        })
        return obj
    }

    //断开连接 清空数据 
    clearChartsData() {
        const Aixiong = this.runtime.ioDevices.Aixiong;
        this.brainScienceData = [this.initTestData(true)];
        Aixiong.brainChartTimer && Aixiong.clearBrainChartTimer();
        this.runtime.emit("DATA_VISUALIZATION", { brainScienceData: this.brainScienceData });
    }

    //获取runMode
    getRunMode() {
        return this.runtime.ioDevices.Aixiong.runMode
    }

    //显示图表
    showBrainCharts() {
        /**isTest为true时 表示模拟数据 */
        const Aixiong = this.runtime.ioDevices.Aixiong;
        const isTest = false;
        if (this.brainScienceData.length == 0) {
            this.brainScienceData = [this.initTestData(true)];
        }
        if (this.brainScienceData.length >= this.maxRecord) {
            this.brainScienceData.shift();
        }
        isTest && this.brainScienceData.push(this.initTestData());
        //首次打开图表
        this.runtime.emit("DATA_VISUALIZATION", { type: 'showChartWindow', brainScienceData: this.brainScienceData });
        Aixiong.brainChartTimer && Aixiong.clearBrainChartTimer();
        //每秒更新一次图表数据
        Aixiong.brainChartTimer = setInterval(() => {
            if (this.brainScienceData.length >= this.maxRecord) {
                this.brainScienceData.shift();
            }
            isTest && this.brainScienceData.push(this.initTestData());
            this.runtime.emit("DATA_VISUALIZATION", { type: 'updateChartWindow', brainScienceData: this.brainScienceData });
        }, 1000);
    }

}

module.exports = Cusoft;
